import React, { Component } from 'react'

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import RadioButton from '../common/radioButton'
import RadioGroup from '../common/radioGroup'
import Privacy from '../common/privacy'
import Controls from '../common/controls'

export default class Questionnaire1 extends Component {
  constructor(props) {
    super(props)
    let questions = {}
    for (let i = 0; i < this.props.questions.length; i++) {
      questions[this.props.questions[i].key] = { value: '', type: 'radio' }
    }
    this.state = {
      input: questions,
      submitClick: false
    }
    this.focusElements = []
    for (let name in this.state.input){
      this.focusElements[name] = React.createRef()
    }

    this.next = this._next.bind(this)
    this.props.updateActivePage(1)
  }

  handleChange(name, valueOrEvent) {
    this.setState({ 
      input: { ...this.state.input, 
        [name]: {...this.state.input[name], 
          value: valueOrEvent 
        }
      }
    })
  }

  isEmpty(name) {
    if (this.state.input[name].value === '') return true
    return false
  }

  isValid(name) {
    return !this.isEmpty(name)
  }

  _next(e) {
    e.preventDefault()
    this.setState({ submitClick: true }, () => {
      for (let property in this.state.input) {
        if (!this.isValid(property)) {
          this.focusElements[property].focus()
          return
        }
      }
      return this.props.next(this.props.match.path, this.state.input)
    })
  }

  displayError(name, message) {
    if (this.state.submitClick) {
      if (!this.isValid(name)) {
        return (
          <div id={`questionnaire_p1_${name}_error`} className="error">{message}</div>
        )
      }
    }
    return <div id={`questionnaire_p1_${name}_error`}></div>
  }

  makeRef(name, ref) {
    this.focusElements[name] = ref
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
  }

  render() {
    const questions = this.props.questions.map(question => 
      <div key={question.key} className="form-input">
        <h3 id={`questionnaire_p1_${question.key}_text`}>{question.text}</h3>
        <RadioGroup 
          name={question.key} 
          radioRef={this.makeRef.bind(this, question.key)} 
          onChange={this.handleChange.bind(this, question.key)} 
          ariaLabelledby={`questionnaire_p1_${question.key}_text`} 
          ariaDescribedby={`questionnaire_p1_${question.key}_error`}
          dataAtId={`questionnaire_p1_${question.key}`}
        >
          {question.fields.map(field => 
            <RadioButton key={field.text} value={field.value} label={field.text} />
          )}
        </RadioGroup>
        {this.displayError(question.key, question.validation.rqerror)}
      </div>
    )

    return (
      <div id="questionnaire_1">
        <AriaMessage message="Navigated to questionnaire page" />
        <Title>{this.props.title}</Title>
        <div className="container">
          {this.props.header.split("\n").map((i) => {
            return <h2>{i}</h2>
          })}
          {questions}
          <Privacy />
          <Controls dataAtId="questionnaire_p1" next={this.next} />
        </div>
      </div>
    )
  }
}